'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCodemirrorSessionId } from 'DesignData/selectors/statusBar';
import { makeGetCodemirrorSelections } from 'DesignData/selectors/codemirror';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import StatusBarSection from 'DesignComponents/statusBar/StatusBarSection';

const statusBarI18nKey = key => `DesignEditorsUI.statusBar.${key}`;

class CodemirrorSelections extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.selections !== nextProps.selections;
  }

  renderLabel() {
    const {
      selections
    } = this.props;

    if (!(selections && selections.length)) {
      return null;
    }

    if (selections.length > 1) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: statusBarI18nKey('codemirrorGroup.selections'),
        options: {
          count: selections.length
        }
      });
    }

    const {
      head
    } = selections[0];
    const column = head.ch + 1;
    const line = head.line + 1;
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: statusBarI18nKey('codemirrorGroup.lineNumbers'),
      options: {
        line,
        column
      }
    });
  }

  render() {
    const label = this.renderLabel();

    if (!label) {
      return null;
    }

    return /*#__PURE__*/_jsx(StatusBarSection, {
      alignRight: true,
      label: label
    }, "code-editor-selections");
  }

}

CodemirrorSelections.propTypes = {
  selections: PropTypes.array
};

const makeMapStateToProps = () => {
  const getSelections = makeGetCodemirrorSelections();
  return state => {
    const sessionId = getCodemirrorSessionId(state);
    return {
      selections: getSelections(state, {
        sessionId
      })
    };
  };
};

export default connect(makeMapStateToProps, null)(CodemirrorSelections);